var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navigationBarPc'),_c('router-view'),_c('bottomInformation'),(_vm.btnFlag)?_c('img',{staticClass:"upper-icon",attrs:{"src":require("./assets/home/upper-icon.png"),"alt":""},on:{"click":function($event){return _vm.goUpper()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }